<!-- src/app/topbar/topbar.component.html -->
<!-- CHANGES: Added dashboard icon button in topbar user-section for navigation -->
<div class="topbar">
    <div class="page-title">
      <h2>{{ getPageTitle() }}</h2>
    </div>
    
    <div class="user-section">

      <!-- Dashboard Quick-Nav Icon -->
      <div class="notification" (click)="navigateToDashboard()" title="Dashboard"
           style="margin-right:8px;">
        <i class="bi bi-speedometer2"></i>
      </div>

      <!-- Notification Bell -->
      <div class="notification" (click)="toggleNotifications($event)">
        <i class="bi bi-bell"></i>
        <span class="badge" *ngIf="unreadCount > 0">
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
      </div>
      
      <div class="user-info">
        <div class="user-details">
          <div class="user-name">{{ username | titlecase }}</div>
          <div class="user-email">{{ useremail }}</div>
          <div class="user-role">{{ userRole }}</div>
        </div>
        <div class="avatar" (click)="logout()">
          <div class="avatar2">
            {{ username?.charAt(0).toUpperCase() }}
          </div>
        </div>
      </div>
    </div>
</div>